import { useAppUrlListener } from '@/hooks/useAppUrlListener';

/**
 * Component that handles deep link navigation.
 * Must be rendered inside BrowserRouter context.
 */
const AppUrlListener: React.FC = () => {
  useAppUrlListener();
  return null;
};

export default AppUrlListener;
